import { Routes } from '@angular/router';
import { adminAuthGuard } from './auth/admin-auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'a', pathMatch: 'full' },
  {
    path: 'sign-in',
    loadComponent: () => import('./auth/sign-in/sign-in.component').then((m) => m.SignInComponent)
  },
  {
    path: 'a',
    canActivate: [adminAuthGuard],
    runGuardsAndResolvers: 'always',
    loadComponent: () =>
      import('./admin-tools/admin-tools.component').then((m) => m.AdminToolsComponent),
    children: [
      { path: '', redirectTo: 'announcement', pathMatch: 'full' },
      {
        path: 'announcement',
        loadComponent: () =>
          import('./announcement/announcement.component').then((m) => m.AnnouncementComponent)
      },
      {
        path: 'avatar',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./avatar/avatar-slot-list/avatar-slot-list.component').then(
                (m) => m.AvatarSlotListComponent
              )
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./avatar/avatar-slot-detail/avatar-slot-detail.component').then(
                (m) => m.AvatarSlotDetailComponent
              )
          }
        ]
      },
      {
        path: 'character',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./character/character-list/character-list.component').then(
                (m) => m.CharacterListComponent
              )
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./character/character-detail/character-detail.component').then(
                (m) => m.CharacterDetailComponent
              )
          }
        ]
      },
      {
        path: 'forum',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./forum/forum-list/forum-list.component').then((m) => m.ForumListComponent)
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./forum/forum-detail/forum-detail.component').then(
                (m) => m.ForumDetailComponent
              )
          }
        ]
      },
      {
        path: 'gift',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./gift/gift-list/gift-list.component').then((m) => m.GiftListComponent)
          },
          {
            path: 'create',
            loadComponent: () =>
              import('./gift/gift-create/gift-create.component').then((m) => m.GiftCreateComponent)
          }
        ]
      },
      {
        path: 'image',
        loadComponent: () =>
          import('./image/image-list/image-list.component').then((m) => m.ImageListComponent)
      },
      {
        path: 'report',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./reports/report-summary/report-summary.component').then(
                (m) => m.ReportSummaryComponent
              )
          },
          {
            path: 'label/:id',
            loadComponent: () =>
              import('./reports/report-label/report-label.component').then(
                (m) => m.ReportLabelComponent
              )
          }
        ]
      },
      {
        path: 'theme',
        loadComponent: () =>
          import('./theme/theme-list/theme-list.component').then((m) => m.ThemeListComponent)
      },
      {
        path: 'topic',
        loadComponent: () => import('./topic/topics.component').then((m) => m.TopicsComponent)
      },
      {
        path: 'tribe',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./tribe/tribe-list/tribe-list.component').then((m) => m.TribeListComponent)
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./tribe/tribe-detail/tribe-detail.component').then(
                (m) => m.TribeDetailComponent
              )
          }
        ]
      },
      {
        path: 'users',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./user/users.component').then((m) => m.UsersComponent)
          },
          {
            path: 'detail/:id',
            loadComponent: () =>
              import('./user/user-detail/user-detail.component').then((m) => m.UserDetailComponent)
          }
        ]
      }
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./not-found/not-found.component').then((m) => m.NotFoundComponent)
  }
];
